import { EntityService } from '../EntityService';

export class InvoiceDiscountList extends EntityService {
  static entity = 'app/invoice-discount-list';

  static getPdf(id: string) {
    return this.axios.get(`${this.entity}/${id}/downloaf-pdf`, { responseType: 'blob' }).then(res => res.data);

  }
}
